var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"person-label doc-version-label",attrs:{"small":"","label":"","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.produceGlobalEvent.apply(null, arguments)}}},[_c('v-icon',[_vm._v(" fas fa-clone ")]),_c('div',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }